import type { Options } from './shareModes';

/**
 * The Facebook channel's event names: `<name>_intent` and `<name>` at the tap, then `<name>_success`,
 * `<name>_failure` or `<name>_cancel` once the composer opens (or does not). The share pipeline and any
 * caller that runs `openFacebookShare` outside it both build them here, so both fire the same names.
 */
export function buildFacebookTrackingEvents(trackingEventName: string): Options['trackingEvents'] {
	return {
		intent: `${trackingEventName}_intent`,
		legacy_success: trackingEventName,
		success: `${trackingEventName}_success`,
		failure: `${trackingEventName}_failure`,
		cancel: `${trackingEventName}_cancel`,
	};
}
